const PreRegSchoolStatusEnum = Object.freeze({
    0: "Undefined",
    1: "NotInitiated",
    2: "InProcess",
    3: "DonePendingIddinkValidation",
    4: "ValidatedByIddink"
});

export default PreRegSchoolStatusEnum;